<template>
<section class="position-relative d-flex align-items-center py-5" id="contact">
    <div class="container-xl">
        <div class="row contact">
            <div class="col-md-7 order-1 order-md-0 d-flex flex-column justify-content-center">
                <img class="mw-100 mh-100" v-if="parent.data" :src="parent.data.contact.url">
            </div>
            <div class="col-md-5 text-md-justify text-center text-white order-0 order-md-1 d-flex flex-column justify-content-center">
                <h1 class="text-primary font-weight-bold" style="font-size: 30px">Kontakt</h1>
                <ul class="list-group list-group-flush mb-2">
                    <li class="list-group-item pl-0">
                        <svg class="bi mr-2" width="18" height="18" fill="currentColor">
                            <use xlink:href="img/icon/bootstrap-icons.svg#envelope-fill"/>
                        </svg>
                        <a class="text-white" v-if="parent.data" v-html="parent.data.contact.email" :href="'mailto:' + parent.data.contact.email"></a>
                    </li>
                </ul>

                <div class="content" v-if="parent.data" v-html="parent.data.contact.content"></div>

                <div class="d-flex justify-content-md-start justify-content-center mt-3">
                    <div class="bg-white rounded-circle mr-2 d-flex justify-content-center align-items-center" style="width: 40px; height: 40px;">
                        <a v-if="parent.data" :href="parent.data.contact.facebook" class="text-dark">
                            <svg class="bi" width="24" height="24" fill="currentColor">
                                <use xlink:href="img/icon/bootstrap-icons.svg#facebook"/>
                            </svg>
                        </a>
                    </div>
                    <div class="bg-white rounded-circle mx-2 d-flex justify-content-center align-items-center" style="width: 40px; height: 40px;">
                        <a v-if="parent.data" :href="parent.data.contact.instagram" class="text-dark">
                            <svg class="bi" width="24" height="24" fill="currentColor">
                                <use xlink:href="img/icon/bootstrap-icons.svg#instagram"/>
                            </svg>
                        </a>
                    </div>
                    <div class="bg-white rounded-circle ml-2 d-flex justify-content-center align-items-center" style="width: 40px; height: 40px;">
                        <a v-if="parent.data" :href="parent.data.contact.youtube" class="text-dark">
                            <svg class="bi" width="24" height="24" fill="currentColor">
                                <use xlink:href="img/icon/bootstrap-icons.svg#youtube"/>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
    export default {
        data(){
            return {
                parent: this.$parent._data,
            }
        },
    }
</script>
